module.exports = __webpack_public_path__ + "img/Porto Apartment - 27 of 85.0e09ce67.jpeg";